import type { CreateIntentReturnRequestDto, ReturnRequestCreateIntentResponseDto } from "../generated/schema";
import { getPublicAuthHeader, getReturnWidgetFetchClient } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";

export async function publicCreatePaymentIntent(
	body: CreateIntentReturnRequestDto,
): Promise<ReturnRequestCreateIntentResponseDto> {
	const { data, error } = await getReturnWidgetFetchClient().POST(
		"/public/return-request/checkout/create-intent",
		{ params: { header: getPublicAuthHeader() }, body },
	);
	if (error) throw error;
	return data;
}

export function usePublicCreatePaymentIntent() {
	return usePublicApiMutation(
		"post",
		"/public/return-request/checkout/create-intent",
		{
			mapVariables: (body: CreateIntentReturnRequestDto) => ({
				params: { header: getPublicAuthHeader() },
				body,
			}),
		},
	);
}
